import { CanvasRoutes } from '@/configs/routes/types';

export const DecisionsRoutes = {
  [CanvasRoutes.Decisions]: {
    name: 'Decisions',
    path: '/decisions',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.DecisionsActivePlanning]: {
    name: 'Home',
    path: '/decisions/active-planning',
    // Hidden from the sidebar per request; route stays live for direct links/breadcrumbs.
    showInNavigation: false,
    showInBreadcrumbs: true,
    breadcrumbGroup: 'Production Quantity & Timing',
  },
  // Sits ahead of Value Opportunity because that is the page a row links out to:
  // the list is how you pick which backtest's summary you are looking at.
  [CanvasRoutes.DecisionsBacktests]: {
    name: 'Backtest Results',
    path: '/decisions/backtests',
    showInNavigation: true,
    showInBreadcrumbs: true,
    breadcrumbGroup: 'Production Quantity & Timing',
    // Keep this page's own crumb: it's the landing page for the group, not just an
    // ancestor of something deeper.
    breadcrumbShowCurrent: true,
  },
  // Between the list and Execute because that is the order of the work: see what past
  // backtests did, build the next one, run it.
  [CanvasRoutes.DecisionsCanvas]: {
    name: 'Decision Canvas',
    path: '/decisions/canvas',
    // Hidden from the sidebar per request; route stays live for direct links/breadcrumbs.
    showInNavigation: false,
    showInBreadcrumbs: true,
    breadcrumbGroup: 'Production Quantity & Timing',
  },
  [CanvasRoutes.DecisionsBacktestDetail]: {
    name: 'Backtest Scenario',
    path: '/decisions/backtests/:scenarioRunId',
    // Reached by clicking a row in Backtest Results — no sidebar entry of its own, same
    // as Product / Stocking Locations.
    showInNavigation: false,
    showInBreadcrumbs: true,
    breadcrumbGroup: 'Production Quantity & Timing',
    // No `breadcrumb` override: it would have to come from the URL, and the scenario id is
    // long enough to crowd the trail. The page heading carries the scenario's label, which
    // is the readable name anyway.
    // This route's path nests under Backtest Results' (/decisions/backtests/:id), so it
    // already gets a "Backtest Results" ancestor crumb for free. Keep this page's own crumb
    // ("Backtest Scenario") too, since — unlike Value Opportunity — the page heading shows
    // the scenario's own label, not this route's name.
    breadcrumbShowCurrent: true,
  },
  [CanvasRoutes.DecisionsExecute]: {
    name: 'Execute',
    path: '/decisions/execute',
    showInNavigation: true,
    showInBreadcrumbs: true,
    breadcrumbGroup: 'Production Quantity & Timing',
    // Keep this page's own crumb, same as Backtest Results: it's a nav-bar landing
    // page for the group, not just an ancestor of something deeper.
    breadcrumbShowCurrent: true,
  },
  [CanvasRoutes.DecisionsValueOpportunity]: {
    name: 'Value Opportunity',
    path: '/decisions/value-opportunity',
    // Hidden from the sidebar per request; route stays live for direct links/breadcrumbs.
    showInNavigation: false,
    showInBreadcrumbs: true,
    breadcrumbGroup: 'Production Quantity & Timing',
    // No `breadcrumbShowCurrent`: this page's own crumb is dropped (default behavior) and
    // replaced by the full "Backtest Results › Backtest Scenario › Run Summary" trail that
    // ValueOpportunityContainer builds via `extraCrumbs` — it needs the real scenarioRunId
    // from the URL/context to link the "Backtest Scenario" crumb, which isn't available to
    // static route config.
  },
  [CanvasRoutes.DecisionsProductStockingLocations]: {
    name: 'Product / Stocking Locations',
    path: '/decisions/product-stocking-locations',
    // Reachable only via Value Opportunity (click a product) — no sidebar entry (Max review).
    showInNavigation: false,
    showInBreadcrumbs: true,
    breadcrumbGroup: 'Production Quantity & Timing',
    // No `breadcrumbShowCurrent`: same as Value Opportunity, this page's own crumb is
    // dropped (default) and replaced by the full "Backtest Results › Backtest Scenario ›
    // Run Summary › Product / Stocking Locations › {site} › {sku}" trail that
    // ProductStockingContainer builds via `extraCrumbs`.
  },
  [CanvasRoutes.DecisionsPolicies]: {
    name: 'Policies',
    path: '/decisions/policies',
    // Hidden from the sidebar per request; route stays live for direct links/breadcrumbs.
    showInNavigation: false,
    showInBreadcrumbs: true,
    breadcrumbGroup: 'Production Quantity & Timing',
  },
};
